/** A workbook, page or element the user picked out of the Sigma file tree. */
export interface ISelectedSigmaObject {
	/** The Sigma workbook id */
	workbookId: string;
	/**
	 * The tenant scoped workbook url. Optional because it comes from `ISigmaFile.url`, which the
	 * Sigma file tree does not guarantee. `workbookId` is the field consumers should rely on.
	 */
	workbookUrl?: string;
	/** Set when a page or an element was picked */
	pageId?: string;
	/** Set when an element was picked */
	elementId?: string;
	/** The name of whichever object was picked (workbook, page or element) */
	name: string;
}

export const sigmaObjectKey = (workbookId: string, pageId?: string, elementId?: string) =>
	`${workbookId}:${pageId ?? ""}:${elementId ?? ""}`;
